import React from 'react';
import PropTypes from 'prop-types';

/**
 * Card Component
 *
 * Reusable card container with optional variants
 *
 * Props:
 * - children: Card content
 * - variant: Style variant (default, dashed, alert, questions)
 * - className: Additional CSS classes
 */
function Card({ children, variant = 'default', className = '' }) {
  const variantStyles = {
    default: 'bg-white border border-gray-200',
    dashed: 'bg-gray-50 border-2 border-dashed border-gray-300',
    alert: 'bg-red-50 border-2 border-red-200',
    questions: 'bg-gradient-to-br from-orange-50 to-white border-2 border-orange-200',
  };

  return (
    <div
      className={`
        ${variantStyles[variant]}
        rounded-2xl p-6 mb-5 shadow-sm
        ${className}
      `}
    >
      {children}
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'dashed', 'alert', 'questions']),
  className: PropTypes.string
};

export default Card;
